module.exports = __webpack_public_path__ + "assets/static/png/verifiedpci.9875137648207a25eb24bb38acc73516.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameFooter/images/verifiedpci.png
 ** module id = 482
 ** module chunks = 1
 **/